require('babel-polyfill');

if (!window.Intl) {
    require('intl');
    require('intl/locale-data/jsonp/en.js');
}
